import {
    ADD_LICENCE_ADDING_LICENCE_FOR_ALREADY_ADDED_SW_PRODUCT_FOR_COMPANY,
    ADD_LICENCE_ERROR,
    ADD_LICENCE_PENDING,
    ADD_LICENCE_SELECT_COMPANY, ADD_LICENCE_SELECT_PRODUCT,
    ADD_LICENCE_SET_ALL_EXPIRY_ACTIONS,
    ADD_LICENCE_SET_ALL_SOFTWARE_PRODUCT_ELEMENTS,
    ADD_LICENCE_SET_ALL_SOFTWARE_PRODUCTS,
    ADD_LICENCE_SET_AVAILABLE_COMPANIES,
    ADD_LICENCE_SET_AVAILABLE_SOFTWARE_PRODUCT_ELEMENTS,
    ADD_LICENCE_SET_COMPANY_HAS_SOFTWARE_PRODUCT,
    ADD_LICENCE_SET_FILTERED_EXPIRY_ACTIONS, ADD_LICENCE_SET_LICENCE_ELEMENTS,
    ADD_LICENCE_SET_PREVIOUSLY_ADDED_PRODUCTS,
    ADD_LICENCE_SUCCESS,
    CLEAR_NEWLY_ADDED_LICENCE
} from "./types";
import {message} from "antd";
import api from "../../api/api";
import {
    COMPANY_ADD_SW_PRODUCTS_URL, company_URL, companyHasSoftwareProduct_URL, expiryLicenceAction_URL,
    LICENCE_POST_URL, softwareProduct_URL, softwareProductElement_URL
} from "../../constants/urlConfig";
import Axios from "axios";
import {batch} from "react-redux";

const loadDependencies = () => async (dispatch, getState) => {
    const darkMode = getState().theme.darkMode;
    try {
        const [companyHasSoftwareProductResponse, softwareProductsResponse, softwareProductElementResponse, companiesResponse, expiryActionsReponse] = await Axios.all([
            api.get(companyHasSoftwareProduct_URL),
            api.get(softwareProduct_URL),
            api.get(softwareProductElement_URL),
            api.get(company_URL),
            api.get(expiryLicenceAction_URL)
        ]);

        const companyHasSoftwareProducts = companyHasSoftwareProductResponse.data,
            softwareProducts = softwareProductsResponse.data,
            elements = softwareProductElementResponse.data,
            companies = companiesResponse.data,
            expiryActions = expiryActionsReponse.data;

        const softwareProductsToDisplay = softwareProducts.map(({id, code}) => ({
            id, value: code
        }));

        batch(() => {
            dispatch(setAllExpiryActions(expiryActions));
            dispatch(setAvailableSoftwareProducts(softwareProductsToDisplay));
            dispatch(setAllSoftwareProductElements(elements));
            dispatch(setAvailableCompanies(companies.map(({id, companyName}) => ({id, value: companyName}))));
            dispatch(setCompanyHasSoftwareProduct(companyHasSoftwareProducts));
        })

    } catch (error) {
        message.error({
            content: 'Failed to load Licence data. Please try again later.',
            className: darkMode && "dark-mode"
        });
    }
};

const setAllExpiryActions = expiryActions => ({
    type: ADD_LICENCE_SET_ALL_EXPIRY_ACTIONS,
    payload: expiryActions
});

const setAvailableSoftwareProducts = availableSoftwareProducts => ({
    type: ADD_LICENCE_SET_ALL_SOFTWARE_PRODUCTS,
    payload: availableSoftwareProducts
});

const setAllSoftwareProductElements = elements => ({
    type: ADD_LICENCE_SET_ALL_SOFTWARE_PRODUCT_ELEMENTS,
    payload: elements
});

const setAvailableSoftwareProductElements = elements => ({
    type: ADD_LICENCE_SET_AVAILABLE_SOFTWARE_PRODUCT_ELEMENTS,
    payload: elements
});

const setAvailableCompanies = companies => {
    return {
        type: ADD_LICENCE_SET_AVAILABLE_COMPANIES,
        payload: companies
    }
};

const setCompanyHasSoftwareProduct = companyHasSoftwareProducts => ({
    type: ADD_LICENCE_SET_COMPANY_HAS_SOFTWARE_PRODUCT,
    payload: companyHasSoftwareProducts
});

const selectCompany = companyId => ({
    type: ADD_LICENCE_SELECT_COMPANY,
    payload: companyId
});

const onCompanyChange = companyId => async (dispatch, getState) => {
    dispatch(selectCompany(companyId));
    const {companyHasSoftwareProducts} = getState().addLicence;

    const companyProducts = companyHasSoftwareProducts.filter(i => i.companyId === companyId);

    dispatch(setPreviouslyAddedProducts(companyProducts));
};

const setPreviouslyAddedProducts = companyProducts => ({
    type: ADD_LICENCE_SET_PREVIOUSLY_ADDED_PRODUCTS,
    payload: companyProducts
});

const onProductsChange = (selectedProductId, selectedProduct, code, callback) => async (dispatch, getState) => {
    const {allExpiryActions, allSoftwareProductElements} = getState().addLicence;
    const filteredExpiryActions = allExpiryActions.filter(({softwareProductId}) => softwareProductId === null || softwareProductId === selectedProductId);
    const availableSoftwareProductElements = allSoftwareProductElements.filter(({softwareProductId}) => softwareProductId === selectedProductId);

    batch(() => {
        dispatch(setAvailableExpiryActions(filteredExpiryActions));
        dispatch(setAvailableSoftwareProductElements(availableSoftwareProductElements));
        dispatch(setAddingLicenceForAlreadyAddedSwProductForCompany(!!code));
        dispatch(setSelectedProduct(selectedProduct));
    });

    if (callback) callback({code: code || selectedProduct.value + '_'});
};

const setSelectedProduct = product => ({
    type: ADD_LICENCE_SELECT_PRODUCT,
    payload: product
});

const setAddingLicenceForAlreadyAddedSwProductForCompany = value => ({
    type: ADD_LICENCE_ADDING_LICENCE_FOR_ALREADY_ADDED_SW_PRODUCT_FOR_COMPANY,
    payload: value
});

const setAvailableExpiryActions = filteredExpiryActions => ({
    type: ADD_LICENCE_SET_FILTERED_EXPIRY_ACTIONS,
    payload: filteredExpiryActions
});

const clearNewlyAddedLicence = () => ({
    type: CLEAR_NEWLY_ADDED_LICENCE
});

const saveLicence = licenceElements => async (dispatch, getState) => {
    const darkMode = getState().theme.darkMode;
    try {
        let companyHasSoftwareProductId;

        dispatch({type: ADD_LICENCE_PENDING});
        if (!licenceElements[0].companyHasSoftwareProductId) {
            const {data} = await api.post(COMPANY_ADD_SW_PRODUCTS_URL, {
                softwareProductId: licenceElements[0].softwareProductId,
                companyId: licenceElements[0].companyId,
                code: licenceElements[0].code
            });
            companyHasSoftwareProductId = data.id;
        } else {
            companyHasSoftwareProductId = licenceElements[0].companyHasSoftwareProductId;
        }

        const {data} = await api.post(LICENCE_POST_URL.replace('{companyHasSoftwareProductId}', companyHasSoftwareProductId), licenceElements);

        dispatch({type: ADD_LICENCE_SUCCESS, payload: data});
        message.success({
            content: "Licence is successfully generated.",
            className: darkMode && "dark-mode"
        });

        if (data.additionalMessage) {
            message.warning({
                content: data.additionalMessage,
                className: darkMode && "dark-mode",
                duration: 10
            });
        }

    } catch (e) {
        message.error({
            content: 'An error has occurred while generating licence.',
            className: darkMode && "dark-mode"
        });
        dispatch({type: ADD_LICENCE_ERROR, payload: e})
    }
};

const setLicenceElements = licenceElements => ({
    type: ADD_LICENCE_SET_LICENCE_ELEMENTS,
    payload: licenceElements
});

const removeLicenceElement = record => async (dispatch, getState) => {
    const { licenceElements } = getState().addLicence;

    const newLicenceElements = licenceElements.filter(el => el.softwareProductElements !== record.softwareProductElements);
    dispatch(setLicenceElements(newLicenceElements));
};

const addLicenceElement = (values, successCallback) => async (dispatch, getState) => {
    const { darkMode } = getState().theme;
    const { availableCompanies, availableSoftwareProductElements, allExpiryActions, licenceElements } = getState().addLicence;

    try {
        values.companyName = availableCompanies.find(c => c.id === values.companyId).value;
        values.softwareProductElement = values.softwareProductId + ' - ' +
            availableSoftwareProductElements.find(i => i.id === values.softwareProductElements).code;
        values.expiryLicenceAction = allExpiryActions.find(({id}) => id === values.expiryLicenceActionId).code;

        const alreadyAddedSwProductElement = licenceElements.find(({softwareProductElements}) => softwareProductElements === values.softwareProductElements);
        if (alreadyAddedSwProductElement) {
            message.error({
                content: "You cannot add the same product twice!",
                className: darkMode && "dark-mode"
            });
            return;
        }

        dispatch(setLicenceElements([...licenceElements, values]));

        if (successCallback) successCallback();
    } catch (exc) {
    }
};

const submitLicence = values => async (dispatch, getState) => {
    const darkMode = getState().theme.darkMode;
    const { addingLicenceForAlreadyAddedSwProductForCompany, selectedProduct, licenceElements } = getState().addLicence;

    try {
        if (!addingLicenceForAlreadyAddedSwProductForCompany) {
            const code = values.code;
            const productPrefix = selectedProduct.value + '_';
            if (!code.startsWith(productPrefix) || code.length <= productPrefix.length) {
                message.error({
                    content: `Product name must start with ${productPrefix} and have at least one character after _`,
                    className: darkMode && "dark-mode"
                });
                return;
            }
        }

        const licenceElementsMapped = licenceElements.map(
            ({quantity, expiryDate, softwareProductElements, code, expiryLicenceActionId, companyId, softwareProductId}) => ({
                quantity,
                expiryDate: expiryDate.toDate(),
                softwareProductElementId: softwareProductElements,
                expiryLicenceActionId,
                companyId,
                softwareProductId: selectedProduct.id,
                code
            }));

        if (addingLicenceForAlreadyAddedSwProductForCompany) {
            licenceElementsMapped.forEach(le => {
                le.companyHasSoftwareProductId = selectedProduct.companyHasSoftwareProductId
            });
        }

        if (licenceElementsMapped.length === 0) {
            message.error({
                content: 'You need to put at least one Element in Licence',
                className: darkMode && "dark-mode"
            });
            return;
        }
        dispatch(saveLicence(licenceElementsMapped));
    } catch (exc) {
        message.error({
            content: 'An error has occurred while saving licences.',
            className: darkMode && "dark-mode"
        });
    }
};

export {loadDependencies, addLicenceElement, setLicenceElements, submitLicence, removeLicenceElement, onProductsChange, onCompanyChange, saveLicence, clearNewlyAddedLicence}